export interface Platform {
  name: string;
  url: string;
  icon: string;
  brand: string;
  desc: string;
  tag: string;
}

export const platforms: Platform[] = [
  {
    name: "微博",
    url: "https://mzniuniu.cn",
    icon: "ri-weibo-fill",
    brand: "#E6162D",
    desc: "热搜榜 · 实时话题爆发地，围观名场面首选",
    tag: "热搜",
  },
  {
    name: "抖音",
    url: "https://www.douyin.com",
    icon: "ri-record-circle-fill",
    brand: "#161823",
    desc: "短视频热议 · 热榜与同城现场更新极快",
    tag: "热榜",
  },
  {
    name: "百度贴吧",
    url: "https://tieba.baidu.com",
    icon: "ri-chat-smile-3-fill",
    brand: "#F08200",
    desc: "贴吧热议 · 兴趣圈子里的深度讨论",
    tag: "热议",
  },
  {
    name: "B站",
    url: "https://www.bilibili.com",
    icon: "ri-tv-2-line",
    brand: "#00A1D6",
    desc: "弹幕现场 · 逐帧细节考据与名场面切片",
    tag: "弹幕",
  },
  {
    name: "小红书",
    url: "https://www.xiaohongshu.com",
    icon: "ri-image-2-line",
    brand: "#FF2442",
    desc: "生活热议 · 话题标签下的真实分享",
    tag: "话题",
  },
  {
    name: "知乎",
    url: "https://www.zhihu.com",
    icon: "ri-question-answer-line",
    brand: "#0084FF",
    desc: "深度讨论 · 事件脉络与来龙去脉梳理",
    tag: "深挖",
  },
  {
    name: "豆瓣",
    url: "https://www.douban.com",
    icon: "ri-film-line",
    brand: "#2E963D",
    desc: "影剧评分 · 作品口碑与长评风向标",
    tag: "口碑",
  },
  {
    name: "快手",
    url: "https://www.kuaishou.com",
    icon: "ri-vidicon-line",
    brand: "#FF4906",
    desc: "百姓现场 · 下沉市场的真实声音",
    tag: "现场",
  },
];

export interface Trend {
  id: number;
  title: string;
  category: string;
  hot: string;
  platforms: string[];
  summary: string;
  time: string;
}

export const categories = ["全部", "影视", "综艺", "网络热梗", "游戏赛事", "生活方式", "文化"];

export const trends: Trend[] = [
  {
    id: 1,
    title: "国产剧口碑持续走高，观众自来水安利刷屏",
    category: "影视",
    hot: "128.6万",
    platforms: ["微博", "豆瓣", "B站"],
    summary: "新剧上线后口碑发酵，细节解析与幕后访谈被反复搬运，讨论热度从豆瓣蔓延到微博广场。",
    time: "刚刚",
  },
  {
    id: 2,
    title: "综艺名场面被逐帧还原，弹幕量一小时破百万",
    category: "综艺",
    hot: "96.2万",
    platforms: ["B站", "抖音"],
    summary: "舞台直拍与幕后花絮片段迅速走红，网友开始在评论区逐帧考据，二次创作热情高涨。",
    time: "10分钟前",
  },
  {
    id: 3,
    title: "新一轮网络热梗诞生，评论区人均玩梗大师",
    category: "网络热梗",
    hot: "213.4万",
    platforms: ["抖音", "微博", "贴吧"],
    summary: "源自日常生活的金句意外破圈，各平台网友接力演绎，梗图与表情包满天飞。",
    time: "25分钟前",
  },
  {
    id: 4,
    title: "电竞赛事总决赛前瞻，粉丝热议谁能夺冠",
    category: "游戏赛事",
    hot: "85.7万",
    platforms: ["贴吧", "B站", "知乎"],
    summary: "选手状态与版本趋势成为讨论焦点，战术分析与预测帖在各个圈子同步升温。",
    time: "40分钟前",
  },
  {
    id: 5,
    title: "年轻人都在聊什么？本周生活方式话题观察",
    category: "生活方式",
    hot: "64.1万",
    platforms: ["小红书", "抖音"],
    summary: "从消费观念到日常爱好，城市里的新鲜话题在笔记与短视频之间来回传递。",
    time: "1小时前",
  },
  {
    id: 6,
    title: "传统技艺短视频一再刷屏，文化内容强势出圈",
    category: "文化",
    hot: "72.9万",
    platforms: ["抖音", "微博", "B站"],
    summary: "非遗手作与古典元素的精良内容持续获得高赞，年轻人对传统文化的热情肉眼可见。",
    time: "2小时前",
  },
  {
    id: 7,
    title: "新片首映口碑两极分化，影评区吵成一团",
    category: "影视",
    hot: "54.8万",
    platforms: ["豆瓣", "微博", "知乎"],
    summary: "预告与正片的落差引发争议，长评与短评各执一词，围观群众也纷纷下场站队。",
    time: "3小时前",
  },
  {
    id: 8,
    title: "网红打卡地突然降温，评论区吵翻了",
    category: "生活方式",
    hot: "48.3万",
    platforms: ["小红书", "抖音", "贴吧"],
    summary: "滤镜与实景的差异被广泛讨论，有人喊退钱，也有人替店家鸣不平，场面一度热闹。",
    time: "4小时前",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "吃瓜路线是什么？",
    a: "吃瓜路线是一个汇总各平台热点入口的内容导航站，把微博热搜、抖音热榜、贴吧热议等常去的讨论现场整理在同一个页面，让你不用到处翻收藏夹，一键就能跳到想围观的地方。",
  },
  {
    q: "入口会不会随时失效？",
    a: "我们收录的都是各平台公开的官方页面与常青入口，稳定性高。若个别页面发生调整，站内会及时更新替换，保证你点进去的始终是最新入口。",
  },
  {
    q: "围观需要注册登录吗？",
    a: "浏览各平台的部分公开内容无需登录即可查看，但发表评论、参与讨论或查看更多内容，通常需要对应平台自己的账号。是否注册由你自行决定。",
  },
  {
    q: "如何快速找到正在热议的话题？",
    a: "优先进入各平台的「热搜榜」「热榜」或「热议」频道，再结合站内整理的今日热议方向，按分类切换到感兴趣的领域，即可快速锁定当下最热闹的现场。",
  },
  {
    q: "围观热点时需要注意什么？",
    a: "热点信息变化很快，建议先在多个平台交叉核对再下结论；对未经证实的传闻保持谨慎，不轻信、不造谣、不传播，尊重当事人隐私，理性表达自己的观点。",
  },
];

export interface Review {
  name: string;
  role: string;
  text: string;
  tag: string;
}

export const reviews: Review[] = [
  {
    name: "小鱼干",
    role: "追剧爱好者",
    text: "以前每次想围观都要在几个App之间来回切，现在一个页面就能看清哪边讨论最热，省事太多了。",
    tag: "微博 · 抖音",
  },
  {
    name: "阿哲",
    role: "电竞观众",
    text: "总决赛期间跟着路线图去贴吧看战术讨论、去B站看复盘，脉络一下子就清楚了，体验很顺。",
    tag: "贴吧 · B站",
  },
  {
    name: "林小满",
    role: "文化内容粉丝",
    text: "入口整理得很清楚，还提醒要理性围观、交叉核对信息，这种负责任的做法让人放心。",
    tag: "抖音 · 知乎",
  },
];